import type { FormInstance } from "antd";
import type { EditInquiryFormValues } from "../type";
import type {
  SrmVendorBiddingDetailVo,
  SrmVendorBiddingDraftVo,
  SrmVendorBiddingSupplierDetailVo,
} from "@/types/apis";
import { useEffect } from "react";
import dayjs from "dayjs";

function isSrmVendorBiddingDetailVo(
  record: SrmVendorBiddingDetailVo | SrmVendorBiddingDraftVo,
): record is SrmVendorBiddingDetailVo {
  return "id" in record;
}

function isSrmVendorBiddingDraftVo(
  record: SrmVendorBiddingDetailVo | SrmVendorBiddingDraftVo,
): record is SrmVendorBiddingDraftVo {
  return record.id === null;
}

export function useInitFormValues(
  form: FormInstance<EditInquiryFormValues>,
  open: boolean,
  recordDetail?: SrmVendorBiddingDetailVo | SrmVendorBiddingDraftVo,
) {
  useEffect(() => {
    if (!open || !recordDetail) {
      return;
    }

    form.setFieldsValue({
      biddingType: recordDetail.biddingType,
      biddingName: recordDetail.biddingName,
      deadline: recordDetail.deadline
        ? dayjs(recordDetail.deadline)
        : undefined,
    });

    if (
      isSrmVendorBiddingDetailVo(recordDetail) &&
      (recordDetail as SrmVendorBiddingDetailVo).id
    ) {
      let supplierDetailList: SrmVendorBiddingSupplierDetailVo[] = [];
      if (
        recordDetail.itemDetailList &&
        recordDetail.itemDetailList.length > 0
      ) {
        const materialItem = recordDetail.itemDetailList[0];
        supplierDetailList = materialItem.supplierDetailList || [];
      }
      form.setFieldsValue({
        itemList: recordDetail.itemDetailList,
        supplierList: supplierDetailList.map((item: any) => item.supplierId),
        supplierDetailList: supplierDetailList,
        purchaseRequestIds: recordDetail.purchaseRequestIds,
        purchaseOrderList: recordDetail.purchaseOrderList,
      });
    }

    if (isSrmVendorBiddingDraftVo(recordDetail) && recordDetail.id === null) {
      form.setFieldsValue({
        itemList: recordDetail.itemList,
        supplierList: recordDetail.supplierUserList?.map((item) => item.id),
        supplierDetailList: recordDetail.supplierUserList?.map((item) => ({
          supplierId: item.id,
          supplierName: item.supplierName,
          supplierUsName: item.supplierUsName,
        })),
        purchaseRequestIds: recordDetail.purchaseRequestIds,
        purchaseOrderList: recordDetail.purchaseRequestList,
      });
    }
  }, [form, open, recordDetail]);
}
